import apiFetch from '../../apiFetch'

export default function (organizedUnitId, salesmanId, changesUO, token) {
  return apiFetch({ endPoint: `Dossier/UpdateUoDossier/${organizedUnitId}/${salesmanId}`, method: 'POST', body: changesUO, token: token })
}
